"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FrontdeskNoEdition = function FrontdeskNoEdition(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M17.01 6.615a3.99 3.99 0 1 1-7.98 0 3.99 3.99 0 0 1 7.98 0Zm-3.99 2.73a2.73 2.73 0 1 0 0-5.46 2.73 2.73 0 0 0 0 5.46Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M19.323 15.995a6.442 6.442 0 0 0-12.605 0H5.435a7.702 7.702 0 0 1 14.957-.901c.09.293-.425.13-.371.437l-.698.464ZM3.292 19.005c0-.657.532-1.19 1.19-1.19h14.664c0 .779 3.5.603 3.5 1.26H4.551v4.34a.63.63 0 0 1-1.26 0v-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M3.781 16.695v1.12h14.49v-1.12H3.781Zm-.7-1.26a.56.56 0 0 0-.56.56v2.52c0 .31.25.56.56.56h15.89c.31 0 .56-.25.56-.56v-2.52a.56.56 0 0 0-.56-.56H3.081ZM14.526 13.93a.63.63 0 0 1 .63-.63h1.68a.63.63 0 0 1 0 1.26h-1.68a.63.63 0 0 1-.63-.63Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M21.771 21a.656.656 0 0 0-1.313 0v1.75a.656.656 0 0 0 1.313 0V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M18.271 17.281v.657h-.438a1.75 1.75 0 0 0-1.75 1.75v4.375c0 .966.784 1.75 1.75 1.75h6.563a1.75 1.75 0 0 0 1.75-1.75v-4.375a1.75 1.75 0 0 0-1.75-1.75h-.438v-.657a2.844 2.844 0 0 0-5.687 0Zm4.375.657v-.657a1.531 1.531 0 0 0-3.063 0v.657h3.063Zm-4.813 1.312h6.563c.242 0 .438.196.438.438v4.375a.438.438 0 0 1-.438.437h-6.563a.438.438 0 0 1-.437-.438v-4.375c0-.241.196-.437.438-.437Z",
    clipRule: "evenodd"
  }));
};
var _default = exports["default"] = FrontdeskNoEdition;